import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import moment from "moment";

export async function loadVeeValidate(locale) {
  if (locale == "vi") locale = "vi";
  const { messages } = await import(`vee-validate/dist/locale/${locale}.json`);
  Object.keys(rules).forEach(rule => {
    extend(rule, {
      ...rules[rule], // copies rule configuration
      message: messages[rule] // assign message
    });
  });
}

export async function loadVeeValidateExtend() {
  extend("check_format_start_date", {
    validate(value) {
      let check = true;
      let start_date_check = moment(value, "DD/MM/YYYY", true);
      if (!start_date_check.isValid()) {
        check = false;
        return check;
      }
      return true;
    },
    params: ["date"],
    message: "contract.error.start_date_format"
  });

  extend("check_format_end_date", {
    validate(value) {
      let check = true;
      let end_date_check = moment(value, "DD/MM/YYYY", true);
      if (!end_date_check.isValid()) {
        check = false;
        return check;
      }
      return true;
    },
    params: ["date"],
    message: "contract.error.end_date_format"
  });

  extend("less_end_time", {
    validate(value, data) {
      let check = true;
      if (value && data.date.end_date) {
        let start_date = value.split("/");
        let end_date = data.date.end_date.split("/");
        let startDate = new Date(
          start_date[2],
          start_date[1] - 1,
          start_date[0]
        ).getTime();
        let endDate = new Date(
          end_date[2],
          end_date[1] - 1,
          end_date[0]
        ).getTime();
        let sumDate = endDate - startDate;
        if (sumDate < 0) {
          check = false;
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: "contract.error.start_date"
  });

  extend("fewer_start_time", {
    validate(value, data) {
      let check = true;
      if (value && data.date.start_date) {
        let start_date = data.date.start_date.split("/");
        let end_date = value.split("/");
        let startDate = new Date(
          start_date[2],
          start_date[1] - 1,
          start_date[0]
        ).getTime();
        let endDate = new Date(
          end_date[2],
          end_date[1] - 1,
          end_date[0]
        ).getTime();
        let sumDate = endDate - startDate;
        if (sumDate < 0) {
          check = false;
        }
        return check;
      }
      return true;
    },
    params: ["date"],
    message: "contract.error.end_date"
  });

  extend('startDateCustomRule', {
    validate(value, [employeeEndDate, rangeTimeEndDate, indexManTime]) {
      if (indexManTime > 0)
        return value >= rangeTimeEndDate;

      return value >= employeeEndDate
    },
    message: "project.error.start_date_rule"
  });

  extend('endDateCustomRule', {
    validate(value, [startDate]) {
      return value >= startDate;
    },
    message: "project.error.end_date_rule"
  });
}
